import {useState, useEffect} from 'react';
import {AutoComplete} from 'antd';
import {getAllVendors} from "../../api/Api";

export const VendorSelectWidget = ({refresh, onSelect, onApiFail, onBlur, props}) => {
    const [vendors, setVendors] = useState([]);
    const [options, setOptions] = useState([]);

    useEffect(() => {
        // get all vendors
        getAllVendors().then(vendors => {
            const options = vendors.map(v => {
                return {
                    ...v,
                    key: v.id,
                }
            });
            setVendors(options);
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        })
    }, [onApiFail, refresh]);

    const onACSelect = (val, option) => {
        if (onSelect) {
            onSelect(val, option);
        }
    }

    const onSearch = (text) => {
        if (vendors === undefined) {
            return;
        }

        const newOptions = vendors.filter(vendor => {
            const ltext = text.toLowerCase();
            return vendor.company.toLowerCase().includes(ltext);
        }).map(v => {
            return {
                value: v.company,
                key: v.id,
                vendor: v
            }
        });
        setOptions(newOptions)
    }

    return <AutoComplete style={{textAlign: 'left', width: '400px'}} placeholder={'vendor'} options={options} onSelect={onACSelect} onBlur={onBlur} onSearch={onSearch}/>
}